import React from 'react'
import { BrickSelector } from './BrickSelector'
import { ColorPicker } from './ColorPicker'
import { CameraControls } from './CameraControls'
import { ActionButtons } from './ActionButtons'
import { useBrickStore } from '@store/brickStore'
import './Toolbar.css'

/**
 * Toolbar Component
 *
 * Main UI toolbar for brick building controls
 *
 * Current features:
 * - Brick type selector (Task 3.1.1)
 * - Color picker (Task 3.1.2)
 * - Camera controls with presets (Task 3.2.5)
 * - Save/Load buttons (Task 4.2.3)
 *
 * Future features:
 * - Rotation controls (Task 3.2.2)
 * - Delete button (Task 3.2.3)
 * - Undo/redo buttons (Task 3.2.4)
 * - Settings/help buttons
 *
 * Layout:
 * - Desktop: Horizontal bar at top of canvas
 * - Mobile: Bottom bar with touch-friendly sizing
 *
 * @component
 */

interface ToolbarProps {
  onSaveSuccess?: () => void
  onLoadSuccess?: () => void
  onLoadError?: (error: string) => void
  onLoadConfirm?: (callback: () => void) => void
}

export const Toolbar: React.FC<ToolbarProps> = ({
  onSaveSuccess,
  onLoadSuccess,
  onLoadError,
  onLoadConfirm,
}) => {
  const selectedBrickType = useBrickStore((state) => state.selectedBrickType)
  const setSelectedBrickType = useBrickStore(
    (state) => state.setSelectedBrickType
  )

  return (
    <div className="toolbar">
      <div className="toolbar__container">
        <div className="toolbar__header">
          <h1 className="toolbar__title">TOOLBAR</h1>
        </div>

        <div className="toolbar__content">
          <BrickSelector
            selectedBrick={selectedBrickType}
            onSelectBrick={setSelectedBrickType}
          />

          <ColorPicker />

          <CameraControls />

          <ActionButtons
            onSaveSuccess={onSaveSuccess}
            onLoadSuccess={onLoadSuccess}
            onLoadError={onLoadError}
            onLoadConfirm={onLoadConfirm}
          />

          {/* TODO: Add more action buttons (rotate, delete, undo/redo) */}
        </div>
      </div>
    </div>
  )
}
